import { Modal, Spinner } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";
import "./OnDemandVideo.scss";

function CloseVideoCallConfirmationModal({show, setShowEndSessionModal, loadingEndSession, endCall, loadingCloseSession, closeCall, sessionTimeExpired}) {
  const busy = loadingEndSession || loadingCloseSession;

  return (
      <Modal className="end-session-modal" size="lg" show={show} onHide={() => {if(!busy){setShowEndSessionModal(false)}}} backdrop="static" keyboard={false} centered>
      <Modal.Header className="p-0">
        <button
          type="button"
          className="close close-button position-relative pb-0"
          disabled={busy}
          onClick={() => {
            setShowEndSessionModal(false);
          }}
        >
          <img src={CloseBtn} alt="modal-close" className="w-30" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <svg className="warning-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L1 21H23L12 2Z" fill="#FDECEA" stroke="#EB2726" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M12 9V14" stroke="#EB2726" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="17.2" r="1.1" fill="#EB2726"/>
          </svg>
          <div className="title">Leave the call?</div>
          <div className="description">
            {sessionTimeExpired
              ? "The session time is up, so it can no longer be ended from here."
              : "Choose how you'd like to leave."}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex-column button-footer">
        {!sessionTimeExpired && <button
          className="btn btn-link end-button"
          type="submit"
          disabled={busy}
          onClick={() => {
            endCall();
          }}
        >
          {loadingEndSession ? (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          ) : (
            <>
              <span className="option-label">End Session</span>
              <span className="option-hint">Consultation is complete — this can't be undone</span>
            </>
          )}
        </button>}
        <button
          className="btn btn-link close-call-button"
          type="submit"
          disabled={busy}
          onClick={() => {
            closeCall();
          }}
        >
          {loadingCloseSession ? (
            <div className="loader">
              <Spinner animation="border" className="spinner" />
            </div>
          ) : (
            <>
              <span className="option-label">Close Call</span>
              <span className="option-hint">{sessionTimeExpired
                ? "Leave the call and return to Teleconsult"
                : "Stepping away — you can rejoin anytime before the session ends"}</span>
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CloseVideoCallConfirmationModal;
